import React, { useEffect, useMemo, useState, useCallback } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CommonDataTable from "../../../components/CommonDataTable";

import { getInventoryListAPI } from "../../../services/inventory/inventory";

const rawColumns = [
  { field: "itemCode", headerName: "Item Code", width: 160 },
  { field: "itemDescription", headerName: "Item Description", width: 200 },
  { field: "locationName", headerName: "Location", width: 180 },
  { field: "locationType", headerName: "Location Type", width: 160 },
  { field: "stockOnHand", headerName: "Stock On Hand", width: 140 },
  { field: "allocatedQty", headerName: "Allocated Qty", width: 140 },
  { field: "availableQty", headerName: "Available Qty", width: 140 },
  { field: "batchLot", headerName: "Batch/Lot", width: 140 },
  { field: "expiryDate", headerName: "Expiry Date", width: 140 },
  { field: "availability", headerName: "Availability", width: 140 },
  { field: "nonSellableQty", headerName: "Non Sellable Qty", width: 160 },
];

export default function InventoryList({ onCreateClick, refreshKey, onView, onEdit }) {

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);

  const [tableRows, setTableRows] = useState([]);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);


  const loadList = useCallback(async (page, pageSize) => {

    try {

      const inventory = await getInventoryListAPI(page, pageSize);

      if (inventory?.data?.length) {

        const formattedRows = inventory.data.map((field) => ({
          id: field._id,
          itemCode: field.itemCode.itemName,
          itemDescription: field.itemDescription,
          locationName: field.locationId.locationName,
          locationType: field.locationId.locationType,
          stockOnHand: field.soh,
          allocatedQty: field.allocatedQty,
          availableQty: field.availableQty,
          batchLot: field.batch,
          expiryDate: new Date(field.batchExpiryDate),
          availability: field.availablity,
          nonSellableQty: field.nonSellableQty,
          __original: field
        }));

        setTableRows(formattedRows);
        setTotalCount(inventory?.pagination?.totalRecords);

      } else {

        setTableRows([]);
        setTotalCount(0);

      }

    } catch (err) {
      console.error(err);
    }

  }, []);


  useEffect(() => {
    loadList(page, pageSize);
  }, [refreshKey, page, pageSize, loadList]);


  const handleOpenMenu = (e, row) => {
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
    setMenuRow(row);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };


  const actionColumn = {
    field: "__actions",
    headerName: "",
    width: 100,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,

    renderCell: (params) => (
      <IconButton
        size="small"
        onClick={(e) => handleOpenMenu(e, params.row)}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
    ),
  };


  const allPossibleColumns = useMemo(
    () => [actionColumn, ...rawColumns],
    []
  );

  const initialVisible = useMemo(
    () => allPossibleColumns.map((c) => c.field),
    [allPossibleColumns]
  );


  return (
    <>

      <CommonDataTable
        allPossibleColumns={allPossibleColumns}
        initialVisible={initialVisible}
        initialRows={tableRows}

        height={520}

        rowsPerPageOptions={[10, 25, 50, 100]}

        exportImportPath="Inventory"

        showCreateButton={true}
        createButtonText="Create Inventory"
        createButtonIcon="bi-plus-lg"

        onCreateClick={onCreateClick}

        createButtonVariant="contained"
        createButtonColor="primary"

        page={page}
        pageSize={pageSize}
        rowCount={totalCount}

        onPageChange={(newPage) => setPage(newPage)}

        onPageSizeChange={(newSize) => {
          setPageSize(newSize);
          setPage(0);
        }}

        onDataRefresh={async ({ filters = [], page: p = 0, pageSize: ps = pageSize } = {}) => {

          console.log("Inventory refresh", { filters, page: p, pageSize: ps });

        }}
      />

      <Menu open={!!menuAnchorEl} anchorEl={menuAnchorEl} onClose={handleCloseMenu}>

        <MenuItem onClick={() => onView(menuRow.__original)}>
          <i className="bi bi-eye me-2" /> View
        </MenuItem>

        <MenuItem onClick={() => onEdit(menuRow.__original)}>
          <i className="bi bi-pencil me-2" /> Edit
        </MenuItem>

      </Menu>

    </>
  );
}